// stores/useLoaderStore.js
import { create } from 'zustand';

export const useLoaderStore = create((set, get) => ({
  requestCount: 0,
  loading: false,

  startLoading: () => {
    const newCount = get().requestCount + 1;
    set({ requestCount: newCount, loading: true });
  },

  stopLoading: () => {
    const newCount = get().requestCount - 1;
    set({
      requestCount: newCount > 0 ? newCount : 0,
      loading: newCount > 0,
    });
  },
}));
